import { axios } from "../lib";
import * as endpoints from "./apiEndpoints";

class EmailService {
  static sendEmail(email) {
    const url = `${endpoints.BASE_URL}${endpoints.SEND_EMAIL}`;
    return axios.post(url, email).then((response) => response.data);
  }
}

export default EmailService;
